/* eslint-disable class-methods-use-this */
/* eslint-disable no-prototype-builtins */
export default class View {
  constructor(wrapper, updateCart) {
    this.wrapper = wrapper;
    this.updateCart = updateCart;

    this.products = this.wrapper.querySelectorAll('.js-cart-product');

    this.promoCode = this.wrapper.querySelector('.js-cart-promo-code');
    this.promoCodeInput = this.promoCode && this.promoCode.querySelector('.js-cart-promo-code-input');
    this.promoCodeResult = this.promoCode && this.promoCode.querySelector('.js-cart-promo-code-result');
    this.promoCodeMessage = this.promoCode && this.promoCode.querySelector('.js-cart-promo-code-message');

    this.cartDiscount = this.wrapper.querySelector('.js-cart-discount');
    this.cartProductsQuantity = this.wrapper.querySelector('.js-cart-products-quantity');
    this.cartSum = this.wrapper.querySelector('.js-cart-sum');

    this.btnContinue = this.wrapper.querySelector('.js-cart-btn-continue');

    this.data = undefined;
  }

  removeDisabledProduct(product) {
    product.remove();
    this.showOrHideBtnContinue();
  }

  removeProduct(product) {
    product.classList.add('removed');
  }

  addProduct(product) {
    product.classList.remove('removed');
  }

  removePromoCode(btnRemove) {
    btnRemove.closest('.js-cart-promo-code-item').remove();
  }

  updateData(data) {
    this.data = data;

    this.renderData();
  }

  renderData() {
    this.renderProducts();
    this.renderPromoCodeResult();
    this.renderPromoCodeMessage();
    this.renderCommonData();

    this.updateCart();
  }

  renderProducts() {
    Object.keys(this.data.items).forEach((item) => {
      const productData = this.data.items[item];

      const product = this.wrapper.querySelector(`.js-cart-product[data-product-id="${productData.productId}"]`);

      if (!product) {
        return;
      }

      const oldPrice = product.querySelector('.js-cart-product-old-price');
      const currentPrice = product.querySelector('.js-cart-product-current-price');
      const totalOldPrice = product.querySelector('.js-cart-product-total-old-price');
      const totalCurrentPrice = product.querySelector('.js-cart-product-total-current-price');

      product.dataset.cartProductId = productData.id;

      if (oldPrice) oldPrice.innerHTML = productData.fullPriceFormatted;
      if (currentPrice) currentPrice.innerHTML = productData.priceFormatted;

      if (totalOldPrice) totalOldPrice.innerHTML = productData.oldSumFormatted;
      if (totalCurrentPrice) totalCurrentPrice.innerHTML = productData.sumFormatted;

      [oldPrice, totalOldPrice].forEach((price) => {
        if (!price) {
          return;
        }

        price.parentElement.classList.toggle('hidden', !productData.discount);
      });
    });
  }

  renderPromoCodeResult() {
    if (!this.promoCodeResult) {
      return;
    }

    if (this.data.couponsList) {
      let items = '';

      Object.keys(this.data.couponsList).forEach((item) => {
        items += `<li class="js-cart-promo-code-item"><span>${this.data.couponsList[item].coupon}</span><button type="button" data-promo-code-value="${this.data.couponsList[item].coupon}" class="js-cart-promo-code-btn-remove"></button></li>`;
      });

      this.promoCodeResult.innerHTML = `<ul>${items}</ul>`;
      this.promoCodeResult.classList.add('visible');
    } else {
      this.promoCodeResult.classList.remove('visible');
    }
  }

  renderPromoCodeMessage() {
    if (!this.promoCode) return;
    if (this.data.hasOwnProperty('couponStatus')) {
      if (this.data.couponStatus) {
        this.promoCodeInput.value = '';
        this.promoCodeMessage.classList.remove('visible');
      } else {
        this.promoCodeMessage.textContent = this.data.couponMessage;
        this.promoCodeMessage.classList.add('visible');
      }
    }
  }

  renderCommonData() {
    if (this.cartDiscount) {
      if (this.data.discountDiff) {
        this.cartDiscount.textContent = this.data.discountDiffFormatted;
        this.cartDiscount.parentElement.classList.remove('hidden');
      } else {
        this.cartDiscount.parentElement.classList.add('hidden');
      }
    }
    this.cartProductsQuantity.textContent = this.data.quantity;
    this.cartSum.innerHTML = this.data.sumFormatted;
  }

  clearPage() {
    if (!this.data) {
      this.data = {};
    }

    const activeProducts = Array.from(this.products).filter((product) => !product.classList.contains('removed') && !product.classList.contains('disabled'));

    if (!activeProducts.length) {
      this.data.discountDiff = 0;
      this.data.discountDiffFormatted = '0';
      this.data.quantity = '0 товаров';
      this.data.sumFormatted = '0';

      this.renderCommonData();
      this.updateCart();
    }
  }

  showOrHideBtnContinue() {
    const disabledProducts = Array.from(this.products).filter((product) => product.classList.contains('disabled'));

    if (disabledProducts.length) {
      this.btnContinue.parentElement.classList.add('disabled');
    } else {
      this.btnContinue.parentElement.classList.remove('disabled');
    }
  }
}
